export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/web_traffic.8ca0115.svg";